import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col
} from 'reactstrap';
import LabelInput from '@src/components/LabelInput/LabelInput';
import { required, maxLength } from '@src/validation';
import ProgressBox from '@src/components/ProgressBox/ProgressBox';

const fieldValidator = {
  name: [required, value => maxLength(value, 255)]
};
class RegionModal extends React.Component {
  constructor(props) {
    super(props);
    const fields = {};
    Object.keys(fieldValidator).forEach(key => {
      fields[key] = {
        value: '',
        visited: false,
        error: false
      };
    });

    this.state = { ...fields };
  }

  updateForm = (event, name) => {
    const inputData = {
      value: event.target.value,
      visited: true,
      error: false
    };

    for (let i = 0; i < fieldValidator[name].length; i++) {
      const validationMsg = fieldValidator[name][i](inputData.value);
      if (validationMsg !== undefined) {
        inputData.error = validationMsg;
        break;
      }
    }

    this.setState({
      [name]: inputData
    });
  };

  submitHandler = e => {
    e.preventDefault();
    const formData = JSON.parse(JSON.stringify(this.state));
    const postData = {};
    let isValid = true;

    Object.keys(fieldValidator).forEach(key => {
      postData[key] = formData[key].value;
      for (let i = 0; i < fieldValidator[key].length; i++) {
        const validationMsg = fieldValidator[key][i](formData[key].value);
        formData[key].visited = true;
        if (validationMsg !== undefined) {
          formData[key].error = validationMsg;
          isValid = false;
          break;
        } else {
          formData[key].error = false;
        }
      }
    });

    this.setState({ ...formData });
    if (isValid) {
      this.props.onSubmit(postData, null);
    }
    return false;
  };

  render = () => {
    return (
      <Modal isOpen={this.props.isActive} toggle={this.props.toggle}>
        <form
          ref={c => {
            this.form = c;
          }}
          onSubmit={this.submitHandler.bind(this)}
        >
          <ModalHeader toggle={this.props.toggle}>
            {'Create New Region'}
          </ModalHeader>
          <div className={'position-relative'}>
            {this.props.loading && <ProgressBox text={'Submiting ...'} />}
            <ModalBody className={'p-4'}>
              <Row>
                <Col>
                  <LabelInput
                    name={'Name'}
                    type={'text'}
                    required={true}
                    {...this.state.name}
                    onChange={event => this.updateForm(event, 'name')}
                  />
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter className={'py-4'}>
              <Button color="light" onClick={this.props.toggle}>
                Cancel
              </Button>
              <Button color="primary" className={'btn px-3'} type={'submit'}>
                Create
              </Button>
            </ModalFooter>
          </div>
        </form>
      </Modal>
    );
  };
}
export default RegionModal;
